import { AppConfig } from '../interfaces/AppConfig';

export default {
    frontendBase: 'https://localhost',
    backendBase: 'https://trunk.intelingu.local',
    apiUrl: 'https://trunk.intelingu.local/ig_frontend_api',
    audioUploadPrefix: 'https://trunk.intelingu.local/wp-content/uploads/audio/audio_file_',
    apiKey: 'hLguST8likp1Bte64iRQeHgTwAXSoSz2wyqMvuIF0Z0NadZs5gaBn4ntvzwM839g',
    sentry: 'https://5e285a3292ba4868903b19345887b374@sentry.mhm-dev.net/4',
    sentryApp: 'https://0b586501896f455aab2daa76738147c1@sentry.mhm-dev.net/7',
    connectionTimeout: 10000,
    // milestoneCards: 500,
    milestoneCards: 20,
} as AppConfig;
